import {svgIconWrapper} from '../svg-icon-wrapper';

import PersonCircleRegular from './person-circle-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PersonCircleRegular {...validProps} />;
}

SvgComponent.iconName = 'personCircleRegular';

export const PersonCircleRegularIcon = svgIconWrapper(SvgComponent);
